import React, { Component } from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { isFreePlan } from '../../utils/planUtils';
import DialogModal from '../common/DialogModal';
import Typography from "material-ui/Typography";
import { compose } from 'redux';

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 0,
    margin: 0,
    minWidth: "600px",
  },

  desc: {
    color: "#181819",
    fontSize: "13px",
  },

  container: {
    background: "#F4F6F9",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    textAlign: "left",
  },

  contact: {
    background: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
    marginTop: "30px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class PromotePaidPlanDialog extends Component {
  initialState = {
    showPromotePaidPlanDialog: false,
    progressIntervalId: null,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  componentDidUpdate(prevProps) {
    if (this.props.user && (!prevProps.user || prevProps.user.id !== this.props.user.id)) {
      if (isFreePlan(this.props.user)) {
        this.setPopupTimestampToCookies(true);
        this.monitorCurrentTime();
      } else {
        this.reset();
      }
    }
  }

  reset = () => {
    this.props.cookies.remove('popupTimestamp', { path: '/' });
    if (this.state.progressIntervalId) {
      clearInterval(this.state.progressIntervalId);
      this.setState({ progressIntervalId: null });
    }
  }

  toggleDialog = () => {
    if (this.state.showPromotePaidPlanDialog) {
      // 開いている状態 -> 閉じる
      if (isFreePlan(this.props.user)) {
        this.setPopupTimestampToCookies();
        this.monitorCurrentTime();
      }
      this.setState({ showPromotePaidPlanDialog: false }) // 万が一有料ユーザーで表示されてしまった場合閉じれるようにした
    } else {
      // 開じている状態 -> 開く
      if (isFreePlan(this.props.user)) {
        this.setState({ showPromotePaidPlanDialog: true })
      } else {
        this.reset();
      }
    }
  }

  monitorCurrentTime = () => {
    const interval = 5000;
    const progressIntervalId = setInterval(() => {
      // 現在の時刻を取得
      const now = new Date();
      const popupTimestamp = this.props.cookies.get('popupTimestamp');

      // クッキーから取得した時刻を Date オブジェクトに変換
      const cookieTime = new Date(popupTimestamp);
      // 現在の時刻とクッキーの時刻を比較
      if (cookieTime < now) {
        this.reset();
        this.toggleDialog();
      }
    }, interval);

    this.setState({ progressIntervalId: progressIntervalId });
  }

  setPopupTimestampToCookies = (isInitial = false) => {
    const popupTimestamp = this.props.cookies.get('popupTimestamp');
    if (!popupTimestamp) {
      const date = new Date();
      const minutes = 10;
      const seconds = 60;
      const milliseconds = 1000;
      const interval = minutes * seconds * milliseconds;
      date.setTime(date.getTime() + (isInitial ? 0 : interval));

      this.props.cookies.set('popupTimestamp', date.toISOString(), { path: '/' });
    }
  }

  renderPromotePaidPlanDialog = () => {
    const { classes } = this.props;

    if (this.state.showPromotePaidPlanDialog) {
      return (
        <DialogModal
          title="有料プランのご案内"
          open={this.state.showPromotePaidPlanDialog}
          aria-labelledby="pop-up-window"
          onClose={this.toggleDialog}
          maxWidth={false}
          classes={{
            paper: classes.paper,
            contentContainer: classes.contentContainer,
          }}
        >
          <div className={classes.container}>
            <div className={classes.desc}>{"有料プランにすると、 ターゲットレコメンドや部門番号を閲覧することができます。 ご希望の方は右下のチャットフォームまたは下記いずれかの方法より、ご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。"}</div>
            <div className={classes.contact}>
              <Typography variant="body2">
                {"担当者から話を聞きたい: "}
                <a className={classes.link} href={process.env.REACT_APP_SPIR_LINK_SOURCE_OTHER} target="_blank" rel="noopener noreferrer">
                  オンラインMTG予約のリンク
                </a>
              </Typography>
              <Typography variant="body2">
                {"メールによるお問い合わせ: "}
                <a className={classes.link} href="mailto:cs@keymanletter.com" target="_blank" rel="noopener noreferrer">
                  cs@keymanletter.com
                </a>
              </Typography>
            </div>
          </div>
        </DialogModal>
      )
    }
  }

  render() {
    return (
      <div>
        {this.renderPromotePaidPlanDialog()}
      </div>
    )
  }
}

PromotePaidPlanDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  cookies: instanceOf(Cookies).isRequired
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default compose(
  withCookies,
  connect(mapStateToProps),
  withStyles(styles)
)(PromotePaidPlanDialog);



// WEBPACK FOOTER //
// ./src/components/Parts/PromotePaidPlanDialog.jsx